module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/mv_sp-b688803be925d50e5160611b7996d633.png";